<app-loading-indicator></app-loading-indicator>
<app-system-info [displaySystemInfo]="displaySystemInfo"></app-system-info>
<mat-sidenav-container class="sidenav-container">
  <!-- Right Drawer -->
  <mat-sidenav #drawerRight class="right-drawer" [disableClose]="true" [opened]="(appRightDrawer.isOpen | async)"
    (openedChange)="rightDrawerOpenChanged($event)" mode="over" position="end">
    <router-outlet name="rightDrawer"></router-outlet>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>